import { Component } from './component';

export class LanguageToggle extends Component {

    setup() {
        this.block1 = document.getElementById('RU-container');
        this.block2 = document.getElementById('EN-container');
	const currentLang = document.querySelector('meta[name="app-locale"]').getAttribute('content');
	if (currentLang === 'ru') {
        	this.block2.style.display = 'none';
        	this.block1.style.display = 'block';
	} else if (currentLang === 'en') {
        	this.block1.style.display = 'none';
        	this.block2.style.display = 'block';
	}
        this.buttonText = document.getElementById('buttonTextLanguageToggle');
        this.buttonText.innerText = 'RU / ENG';
        this.$el.addEventListener('click', this.click.bind(this));
    }

    click(event) {
        event.preventDefault();
        
        const currentLanguage = document.documentElement.lang;
        const newLanguage = currentLanguage === 'ru' ? 'en' : 'ru';

        console.log('Current language:', currentLanguage);
        console.log('New language:', newLanguage);
	console.log(document.documentElement.lang);

        fetch(`/language/${newLanguage}`)
            .then(response => {
                if (response.ok) {
                    console.log('Language change successful');
		    window.location.reload();                    
                } else {
                    console.error('Error changing language:', response.statusText);
                }
            })
            .catch(error => console.error('Error changing language:', error));
    }
}
